<div class="hidden flex-wrap items-center space-x-4 lg:flex lg:space-x-8">
  @for (item of navItems(); track item.url ?? item.dropdown ?? item.name) {
    @if (item.dropdown !== 'languageMenu') {
      <div class="relative">
        @if (item.dropdown) {
          <button
            class="flex items-center font-medium text-neutral-800 transition-colors duration-300 hover:text-orange-500"
            [class.text-orange-500]="hasActiveChild(item)"
            [attr.aria-expanded]="
              dialogService.isOpen(item.dropdown) ? 'true' : 'false'
            "
            [attr.aria-label]="item.name + ' dropdown'"
            (click)="toggleDropdown(item.dropdown, $event)"
          >
            <span>{{ item.name | translate }}</span>
            <img
              class="ml-3 h-4 w-4 transition-transform duration-300"
              [ngClass]="{ 'rotate-180': dialogService.isOpen(item.dropdown) }"
              src="/assets/icons/arrow_down.svg"
              alt="Arrow Down"
            />
          </button>
          @if (isDropdownOpen(item.dropdown!)) {
            <div
              class="absolute left-0 z-50 mt-2 min-w-[200px] origin-top-left transform rounded-xl border border-[#b0b7ba] bg-white p-2 transition-all duration-200 ease-out"
              (clickOutside)="closeDropdown(item.dropdown!)"
              dhpClickOutside
            >
              @for (
                dropdownItem of item.dropdownItems;
                track dropdownItem.url ?? dropdownItem.name
              ) {
                <button
                  class="w-full px-4 py-2 text-left text-base leading-normal font-medium text-[#323739] transition-colors duration-200 hover:text-orange-500"
                  [class.text-orange-500]="isRouteActive(dropdownItem.url)"
                  [routerLink]="dropdownItem.url"
                  (click)="handleDropdownItemClick(item)"
                  tabindex="0"
                >
                  {{ dropdownItem.name | translate }}
                </button>
              }
            </div>
          }
        } @else {
          <a
            class="flex items-center font-medium text-neutral-800 transition-colors duration-300 hover:text-orange-500"
            [routerLink]="item.url"
            [routerLinkActiveOptions]="{ exact: true }"
            [attr.aria-label]="item.name"
            routerLinkActive="text-orange-500"
          >
            <span class="ml-2">{{ item.name | translate }}</span>
          </a>
        }
      </div>
    }
  }
</div>
